import React from "react";
import GoalServices from "./../../../../services/goal.services";
import ImgIconComp from "../../../imgcomp";
import {withTranslation} from "react-i18next";
export default withTranslation()(class AsanaLogin extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			renderHelp: false,
			login_error: false,
			showPatError: false
		};
		this.loginAsana = this.loginAsana.bind(this);
		this.asanaHelpPopup = this.asanaHelpPopup.bind(this);
		this.closeAssanaPopup = this.closeAssanaPopup.bind(this);
		this.GoalServices = new GoalServices();
	}

	loginAsana() {
		let _this = this;
		let app = "asana";
		let userToken = this.asanaPerTok.value;
		let { actions } = this.props;
		if (!userToken || userToken == "" || userToken.length == 0) {
			this.setState({
				showPatError: true
			});
		} else {
			this.GoalServices.authenticateExtApp({
				app: app,
				access_token: userToken,
				scope: "import"
			}).then(function (response) {
				if (response && response.data && response.data.status == "success") {
					actions &&  actions.updateExtApp("asana");
					_this.props.updateAsanaLogin();
				} else {
					_this.setState({
						login_error: true
					});
				}
			});
		}
	}

	asanaHelpPopup() {
		this.setState({ renderHelp: !this.state.renderHelp });
	}

	closeAssanaPopup() {
		this.props.closeAsanaLogin();
	}

	render() {
		const { t } = this.props
		return (
			<div id="myModal" className="aEmodal jiraOverLay">
				<div id="asaLoginIntg" className="jiraOverlayPadding">
					<div className="ws-import-login-assana asanaLogin">
						<div>
							<img
								width="175px"
								className="marTop10Less"
								src={wbConfig.baseUrl + "/images/icons/integration/assana.png"}
							/>
							<div
								className="closeGitPopup right clickable"
								onClick={e => this.closeAssanaPopup()}
							>
								<ImgIconComp id="close" />
							</div>
						</div>

						<div className="login-popup-row">
							<div className="login-popup-col padding6 lable">
								{t(`Allow Workboard to access your Asana's account`)}
              </div>
						</div>

						{this.state.renderHelp && (
							<div id="asanHelpPopup">
								<AsanaHelp closeHelpPopup={this.asanaHelpPopup} />
							</div>
						)}

						<div className="login-popup-row">
							<div className="login-popup-col">
								<div className="login-input-label padding6">
									<span className="label-head">{t('Personal Access Token')}</span>{" "}
									<span className="required">{t(`(required)`)}</span>
								</div>
								<div className="login-input-label asana-access-token padding6">
									{t('Please follow the steps')}{" "}
									<span
										className="clickHere"
										onClick={e => this.asanaHelpPopup()}
									>
										{t('here')}
                  </span>{" "}
									{`${t("to get a Asana's personal access token.")} ${t('Paste the token in the field mentioned below.')}`}
                </div>
								<div className="padding6">
									<input
										placeholder={t("access token")}
										className="login-text-input"
										type="password"
										name="asana_personal_token"
										id="asana_personal_token"
										ref={node => (this.asanaPerTok = node)}
										autocomplete="off"
									/>
								</div>
								{this.state.showPatError && (
									<div className="errorTxt">
										{t(`Please enter PERSONAL ACCESS TOKEN`)}
                  </div>
								)}
							</div>
						</div>

						<div className="login-popup-row">
							<div className="login-popup-col padding6">
								<input
									type="button"
									className="login-btn asanaLoginBtn gbl-btn"
									value={t("Yes, Continue")}
									onClick={e => this.loginAsana()}
								/>
								{this.state.login_error && (
									<p className="login-error-msg login-error-msg-show">
										{t('Authorization failed- check your Asana public access token')}
                  </p>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
})

withTranslation()(class AsanaHelp extends React.Component {
	render() {
		return (
			<div id="myModal" className="aEmodal jiraOverLay jiraOverlayPadding">
				<div className="asanaHelpPopup">
					<div
						className="closeGitPopup right clickable"
						onClick={e => this.props.closeHelpPopup()}
					>
						<ImgIconComp id="close" />
					</div>
					<div className="helpWrap">
						<div>
							{t('1- Click')} <span className="clickHere">{t('here')}</span> {t('and login to your account')}
              <br />
							{t('2- Click on your profile photo')}
              <br />
							{t('3- Click on My Profile Setting')}
              <br />
							{t('4- Click on Apps tab')}
              <br />
							{t('5- Click on Manage Developer Apps')}
              <br />
							{t('6- Under PERSONAL ACCESS TOKENS, click on Create New Personal Access Token')}
              <br />
							{t('7- Put any description that you would remember and click on Create button')}
              <br />
							{(`8- Copy the token and go back to your Workboard's import workstream window, paste the token`)}
            </div>
					</div>
				</div>
			</div>
		);
	}
})
